import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface MaintenanceProps {
  message?: string | null;
  endsAt?: number | null;
}

const Maintenance = ({ message, endsAt }: MaintenanceProps) => {
  return (
    <main className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-b from-background to-muted/40 px-4">
      <div className="w-full max-w-md rounded-2xl border border-border/60 bg-card/80 backdrop-blur-sm p-8 text-center shadow-lg">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <svg
            className="h-7 w-7 text-primary"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.75}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.7 6.3a4 4 0 0 0 5 5l-9 9a2.8 2.8 0 0 1-4-4l9-9Z"
            />
          </svg>
        </div>

        <h1 className="text-xl font-semibold text-foreground">Maintenance en cours</h1>

        <p className="mt-3 text-sm text-muted-foreground">
          {message?.trim() ||
            "Nous effectuons une maintenance technique. L'application sera de nouveau disponible très prochainement."}
        </p>

        {endsAt ? (
          <p className="mt-4 text-sm font-medium text-foreground">
            Retour estimé : {format(new Date(endsAt), "d MMMM 'à' HH'h'mm", { locale: fr })}
          </p>
        ) : null}

        <Button className="mt-6 w-full" onClick={() => window.location.reload()}>
          Réessayer
        </Button>

        <p className="mt-4 text-xs text-muted-foreground">
          Vos données sont en sécurité. Aucune action n'est possible pendant l'intervention.
        </p>
      </div>
    </main>
  );
};

export default Maintenance;
